import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    padding: [theme.spacing(3), 0],
    [theme.breakpoints.up('mobile')]: {
      padding: [theme.spacing(3), 0, theme.spacing(4)],
    },
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    margin: [4, 0, 26],
    [theme.breakpoints.up('mobile')]: {
      margin: [theme.spacing(1), 0, theme.spacing(8)],
      gridTemplateColumns: 'repeat(6, 1fr)',
    },
  },
  formControl: {
    marginBottom: 0,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
      justifyContent: 'center',
    },
  },
  button: {
    marginBottom: theme.spacing(3),
    borderColor: theme.palette.colors.teal,
    [theme.breakpoints.up('mobile')]: {
      width: 244,
      '&:last-child': {
        marginLeft: theme.spacing(3),
      },
    },
  },
  active: {
    color: theme.palette.colors.teal,
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/LicensedStates/components/LicensedStatesForm/useStyles.js